// A&K Usa TOC: 3000
// A&K UK TOC: 401
// A&K AUS TOC: 1000
// A&K South Africa DMC: 2801
// A&K Tanzania DMC: 2805

// Cox & Kings UK: 2900
// Cox & Kings AUS: 2901
// Cox & Kings USA: 2902


export function isCrystalCompany(companyID?: number): boolean {
  return companyID === 999 || companyID === 98;
}

export function isAkCompanies(companyID?: number): boolean {
  return companyID === 1000 || companyID === 401 || companyID === 3000 || companyID === 2801 || companyID === 2805;
}

export function isAkTocCompanies(companyID?: number): boolean {
  return companyID === 1000 || companyID === 401 || companyID === 3000;
}

export function isCoxAndKingCompanies(companyID?: number): boolean {
  return companyID === 2900 || companyID === 2901 || companyID === 2902;
}

export function isCoxAndKingUkCompany(companyID?: number): boolean {
  return companyID === 2900;
}

export function isCoxAndKingAustraliaCompany(companyID?: number): boolean {
  return companyID === 2901;
}

export function isAKAustraliaTocCompany(companyID?: number): boolean {
  return companyID === 1000;
}

export function isAKUkTocCompany(companyID?: number): boolean {
  return companyID === 401;
}

export function isAkUsaTocCompany(companyID?: number): boolean {
  return companyID === 3000;
}

export function isHeritageCompany(companyID?: number): boolean {
  return companyID === 5000;
}

export function isAkSanctuaryPaCompany(companyID?: number): boolean {
  return companyID === 960;
}

export function isAkSouthAfricaDmcCompany(companyID?: number): boolean {
  return companyID === 2801;
}

export function isAkTanzaniaDmcCompany(companyID?: number): boolean {
  return companyID === 2805;
}